const contact = {
    title: 'Neem Contact Op',
    subtitle: 'We zijn er om je te helpen je perfecte ervaring in Abruzzo te plannen',
    companyInformation: 'Bedrijfsinformatie',
    authenticExperiences: 'Authentieke ervaringen in Abruzzo',
    address: 'Adres',
    phone: 'Telefoon',
    email: 'E-mail',
    vatNumber: 'BTW-nummer',
    openingHours: 'Openingstijden',
    mondayFriday: 'Maandag - Vrijdag',
    saturday: 'Zaterdag',
    sunday: 'Zondag',
    closed: 'Gesloten',
    sendRequest: 'Verstuur een Verzoek',
    nameLabel: 'Naam *',
    subjectLabel: 'Onderwerp *',
    emailLabel: 'E-mail *',
    phoneLabel: 'Telefoon (optioneel)',
    phoneOptional: 'Telefoon (optioneel)',
    messageLabel: 'Beschrijving van het Verzoek *',
    messagePlaceholder: 'Beschrijf je verzoek, vragen of speciale verzoeken...',
    namePlaceholder: 'Jouw naam',
    emailPlaceholder: 'jouw-email@voorbeeld.nl',
    subjectPlaceholder: 'Onderwerp van het bericht',
    submitButton: 'Verstuur Verzoek',
    submitting: 'Verzenden...',
    successMessage: 'Bedankt! Je verzoek is succesvol verzonden. We zullen snel antwoorden.',
    errorMessage: 'Er is een fout opgetreden. Probeer het later opnieuw.',
    charactersRemaining: 'tekens over',
    charactersLeft: 'tekens over',
    nameInvalidChars: 'Naam kan alleen letters, spaties, koppeltekens en apostrofs bevatten',
    subjectInvalidChars: 'Onderwerp kan alleen letters, cijfers, spaties en basis interpunctie bevatten'
};

export default contact;

